import { useCreateFieldGetter } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Composable for TicketInfo component customisation
 * Returns ticket info text color, subtext color, and background color
 */
export const useTicketInfoCustomisation = () => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CONVERSATION_DETAILS_PAGE,
    sectionKey: PUI.CONVERSATION_DETAILS_SECTION_KEYS.CONVERSATION_INFO,
    blockKey: PUI.CONVERSATION_DETAILS_BLOCK_KEYS.CONVERSATION_DETAILS,
  });

  const textColor = getField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);
  const subTextColor = getField(PUI.COMMON_FIELD_KEYS.SUB_TEXT_COLOR);
  const backgroundColor = getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR);

  return {
    isVisible,
    textColor,
    subTextColor,
    backgroundColor,
  };
};
